import { Locale } from '@lalalilo/enums'
import { useTranslation } from 'react-i18next'
import { useLocalStorage } from 'react-use'
import styled from 'styled-components'
import { Color, CustomColor } from '../../common/style/color'
import { NewTabLink } from '../../common/style/components/links'
import { BannerBox } from '../../cookies/common'
import { TeachAppPath, useTeachAppLink } from '../../external-links'
import { getLocale } from '../../i18n/locale'
import { ReactComponent as TopIllustration } from './assets/top-illustration.svg'

const TNE_ACCESS_DOC_LINK =
  'https://intercom.help/lalilo/en/articles/6502731-acces-a-lalilo-via-les-tne'

export const TNEBanner: React.FC = () => {
  const [t] = useTranslation('tne_banner')
  const teachAppLink = useTeachAppLink()
  const [isTNEBannerSeen, setIsTNEBannerSeen] = useLocalStorage(
    'is_tne_banner_seen',
    false
  )

  const locale = getLocale()

  if (locale !== Locale.FR || isTNEBannerSeen === true) {
    return null
  }

  return (
    <Banner onClose={() => setIsTNEBannerSeen(true)}>
      <TopIllustration />
      <ContentWrapper>
        <Title>{t('title')}</Title>
        <Description>{t('description')}</Description>
        <Notes>{t('notes')}</Notes>
        <SubscribeLink
          to={teachAppLink(TeachAppPath.FRENCH_SIGN_UP)}
          onClick={() => setIsTNEBannerSeen(true)}
        >
          {t('subscribe')}
        </SubscribeLink>
        <LearnMoreLink href={TNE_ACCESS_DOC_LINK} target="_blank">
          {t('learn_more')}
        </LearnMoreLink>
      </ContentWrapper>
    </Banner>
  )
}

const Banner = styled(BannerBox)`
  width: 340px;
  top: 85px;
  right: 60px;
  bottom: unset;
  left: unset;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${Color.grey_600};
  padding: 20px;
`

const Title = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
`

const Description = styled.p`
  font-size: 16px;
`

const Notes = styled.p`
  margin: 0;
  text-align: center;
  font-size: 10px;
`

const SubscribeLink = styled(NewTabLink)`
  margin: 20px 0px;
  padding: 10px 30px;
  width: 240px;
  background-color: ${CustomColor.canopeGreen};
  color: ${Color.white};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
`

const LearnMoreLink = styled.a`
  cursor: pointer;
  text-decoration-line: underline;
  font-size: 14px;
  color: ${CustomColor.canopeGreen};
`
